<div class="light-gray-bg tiny-padding-all minor-margin-bottom">
  <div class="grid-x">
    <div class="cell auto break-word">
      {{title}}: <b>{{data.type}}</b>
    </div>
    <div class="cell shrink margin-left">
      @if (!isArray) {
        <button (click)="delete()" attr.aria-label="Delete '{{title}}'" title="Delete"><svg-icon aria-hidden="true" icon="icon-trash" class="small dark-gray cursor-pointer"></svg-icon></button>
      }
      <button (click)="edit()" attr.aria-label="Edit '{{title}}'" title="Ddit"><svg-icon icon="icon-pencil" aria-hidden="true" class="small dark-gray cursor-pointer"></svg-icon></button>
    </div>
  </div>
</div>